// Use inverted messages if key pair doesn't exist in retrive message api
const invertedMessages: Record<string, string> = {
  'SOD Violations Workbench Disabled': 'sod.violations.disabled.title',
  'The SOD Violations Workbench is currently disabled. Please reach out to your administrator or raise a support ticket to enable this service.':
    'sod.violations.disabled.message',
  '{age} days': 'neo.aag.days_age',
  '{count} Critical Violations':
    'neo.aag.ad_filter_opt_critical_violation_count',
  '{count} filter applied': 'neo.aag.filter_applied',
  '{count} High Violations': 'neo.aag.ad_filter_opt_high_violation_count',
  '{count} Low Violations': 'neo.aag.ad_filter_opt_low_violation_count',
  '{count} Medium Violations': 'neo.aag.ad_filter_opt_mediumviolation_count',
  '{count} of the {totalCount} mitigating controls expires soon':
    'neo.aag.controls_expire_soon_count_msg',
  '{count} of the {totalCount} mitigating controls has expired':
    'neo.aag.controls_expired_count_msg',
  '{count} of the {totalCount} mitigating controls have expired':
    'neo.aag.controls_expired_multiple_count_msg',
  '{count} selected violations': 'neo.aag.selected_violations_count',
  '{count} violations selected': 'neo.aag.violations_selected_plural',
  '{count} of {total} violations selected':
    'neo.aag.violations_of_total_selected',
  '{count} Very High Violations':
    'neo.aag.ad_filter_opt_very_high_violation_count',
  '{count} Very Low Violations':
    'neo.aag.ad_filter_opt_very_low_violation_count',
  '+{count} More': 'neo.aag.plus_more_count',
  A: 'neo.aag.ad_filter_opt_A',
  'A to Z': 'neo.aag.sort_a_to_z',

  Account: 'Account_DISPLAYNAME.CERTIFICATIONS',
  'Account Status': 'sod.accounts.status.label',

  'Account type1': 'neo.aag.ad_filter_opt_acc_type_1',
  'Account type2': 'neo.aag.ad_filter_opt_acc_type_2',
  Accounts: 'AccountsLabel',
  'Accounts with Most Violations': 'neo.aag.widget_account_most_violation',
  'Action Failed': 'CERTS_ACTION_FAILED',
  Active: 'CERTS_LIST_ACTIVE',
  'Actual Risk': 'neo.aag.ad_filter_opt_actual_risk',

  'Actual vs Potential status is not calculated':
    'neo.aag.actual_vs_potential_not_calculated',
  Add: 'Add',
  'Add Mitigating Control': 'neo.aag.add_mitigating_control',
  'Add or Remove Filters': 'CERTS_ADD_OR_REMOVE_FILTERS',
  'Add Review Comments': 'neo.aag.add_review_comment',
  'Added by': 'neo.aag.added_by',
  'An error occurred while processing your request. Please verify your input or try again later.':
    'neo.aag.api_error_processing_msg',
  'Activity summary unavailable. Please try again later':
    'activitylog.error.activityDetailsUnavailable',
  Application: 'Search.Label.Application',
  'Applications with Most Violations':
    'neo.aag.widget_application_most_violation',
  'Applied Mitigating Control ({count})':
    'neo.aag.mitigatedTab.details.mitigatingControl.title.count',
  Apply: 'advancefilter.label.Apply',
  'Apply one or more mitigating controls to violation':
    'neo.aag.apply_mitigating_controls_message',
  '{count, plural, one {Assigned Entitlement} other {Assigned Entitlements}}':
    'neo.aag.assigned_entitlement_and_entitlements',
  'Assigned Entitlements Causing Most Violations':
    'neo.aag.widget_ass_ent_most_violation',
  B: 'neo.aag.ad_filter_opt_B',
  Back: 'activitylog.flag.back.label',
  'Business Process': 'neo.aag.ad_filter_bp',
  'Business Process with Most Violations': 'neo.aag.widget_bp_most_violation',
  C: 'neo.aag.ad_filter_opt_C',
  Cancel: 'activitylog.export.cancel.label',
  Submit: 'activitylog.completeReview.submit',
  'Change End Date': 'CERTS_CHANGE_END_DATE',
  'Change Mitigating Control End Date':
    'neo.aag.change_mitigating_control_end_date',
  'Change Mitigating Control End Date ({count})':
    'neo.aag.change_mitigating_control_end_date_count',
  'Change Mitigating Controls': 'neo.aag.change_mitigating_control',
  'Change Review End Date': 'neo.aag.change_review_end_date',
  City: 'City.Default.label',
  clear: 'CopyAccess.searchbar.clear',
  Clear: 'CERTS_CLEAR',

  'Clear Selection': 'CERTS_BULK_CLEAR_SELECTION',
  Closed: 'neo.aag.violations_page_closed_tab',
  'Collapse All': 'neo.aag.collapse_all',
  Comments: 'activitylog.reviewDetail.comments.label',
  'Company Name': 'companyname.sod.label',
  'Conflicting Job Functions': 'CERTS_CONFLICT_JOB_FUNCTIONS',
  'Consult ({count})': 'neo.aag.consult_count',
  'Contractors with Most Violations': 'neo.aag.widget_contract_most_violation',
  'Cost Center': 'Costcenter.Default.label',
  'Cost Centers with Most Violations': 'neo.aag.widget_cc_most_violation',
  'Could not Load Page': 'CERTS_GLOABL_ERROR_TITLE',
  Country: 'country.sod.label',
  Critical: 'SOD.RiskType.Critical',
  CRITICAL: 'neo.aag.ad_filter_opt_critical_uppercase',
  'Critical ({riskScore})': 'neo.aag.risk_score_type_critical',
  'Critical Access': 'neo.aag.ad_filter_opt_critical_access',
  CsnOnly: 'neo.aag.ad_filter_opt_csn',
  'Custom ({value})': 'neo.aag.ad_filter_opt_custom_val',
  'Custom Property 1': 'EntitlementTypeDetails.Label.CustomProperty1',
  Customize: 'neo.aag.customize',
  'Customize Widgets': 'neo.aag.customize_widgets',
  "Data couldn't be retrieved.": 'neo.aag.insights.error.message',
  'days old': 'neo.aag.ad_filter_opt_days_old',
  Department: 'neo.aag.ad_filter_department',
  'Departments with Most Violations': 'neo.aag.widget_dep_most_violation',
  Description: 'activitylog.insight.description.label',
  'details panel': 'neo.aag.details_pane',
  Detective: 'neo.aag.ad_filter_opt_detective',
  'Display Name': 'displayname.sod.label',
  'Displaying items related to the widget: ': 'neo.aag.display_widget_item_msg',
  'Displaying violations selected in the graph: ':
    'neo.aag.display_graph_violations',
  Email: 'email.sod.label',
  'Employee Class': 'employeeclass.sod.label',
  'Employee ID': 'Users.employeeid.label',
  'Employee Type': 'employeeType.sod.label',
  End: 'quickRequest.End',
  'End Date': 'activitylog.export.endDate.label',
  'Enter the application name to search': 'neo.aag.application_search_filter',
  'Enter at least 1 character to view options.': 'neo.aag.ad_search_filter',
  'Entitlement assigned to the account that led to the violation of this function.':
    'neo.aag.conflict_fn_tooltip_msg',
  'Entitlement Type': 'entitlement.entitlementtypekey.label',
  'Entitlement Value': 'entitlement.entitlement_value.label',
  'Entitlement Value Name': 'neo.aag.ad_filter_entitlement_value_name',
  'Entitlements with Inherent Risk': 'neo.aag.entitlement_inherent_risk',
  Entity: 'entity.sod.label',
  'Error loading Mitigating Control details, please try again.':
    'neo.aag.mitigatedTab.details.mitigatingControl.error',
  'Error loading summary details, please try again.':
    'neo.aag.api_error_details_msg',
  'Error loading User details, please try again.':
    'neo.aag.error_loading_user_details',
  'Expand Next Level': 'neo.aag.expand_next_level',
  'Expand/Collapse': 'neo.aag.expand_collapse',
  'Expired.': 'neo.aag.expired_with_dot',
  Expires: 'NewRequestHome.RecentRequests.Expires.Column.Label',
  'Expires Soon.': 'neo.aag.expire_soon',
  Filter: 'CERTS_FILTER',
  FIREFIGHTERID: 'neo.aag.ad_filter_opt_firefighterid',
  'First Name': 'FirstName.Default.label',

  Function: 'AOB.ORACLE-EBS.ENTITLEMENT_FIELD_MAPPING.FUNCTION.title',
  'Function Status': 'function.status.label',
  'Generate Report': 'neo.aag.generate_report',
  'Generate Report ({count})': 'neo.aag.generate_report_count',
  Glossary: 'Role_GLOSSARY.ATTESTATIONS',
  'Go Back': 'activitylog.error.goBack',
  'Feature Disabled': 'activitylog.featureNotEnabled.title',
  'The Activity Log Viewer feature is currently disabled. Please contact your administrator.':
    'activitylog.featureNotEnabled.subtitle',
  'Go to Home Page': 'activitylog.featureNotEnabled.goToHome',
  'Export Activity Log': 'activitylog.export.title.label',
  Findings: 'activitylog.insight.findings.label',
  'No Findings Available': 'neo.aag.insights.empty',
  'Request Details': 'activitylog.header.requestDetail.label',
  'The number of visible attributes depends on the size of your browser. Any attributes not shown are visible in the details panel.':
    'neo.aag.auditLog.columnFilter.visibleAttributesNote',
  Time: 'neo.common.time',
  'Back to insights list': 'neo.aag.insights.back_to_list',
  'Entitlement Details': 'neo.aag.insights.entitlement.details',
  Deviate: 'activitylog.deviation.label',
  'Description:': 'neo.aag.insights.description.label',
  'Usage Count:': 'neo.aag.insights.usage.count.label',
  'N/A': 'neo.common.na',
  'No Data to show': 'neo.aag.insights.no_data',
  'View Logs': 'neo.aag.logs.view',
  More: 'neo.common.more',
  'Something went wrong while loading the page.':
    'neo.aag.common.error.page_load',
  'Try refreshing, or check back later. If the issue persists, contact your administrator.':
    'neo.aag.common.error.suggestion',
  'No activity recorded for this session': 'neo.aag.session.no_activity',
  'This session was not used, so there are no recordings or log details to review.':
    'neo.aag.session.no_details',
  'The number of visible attributes depends on the size of your browser.':
    'neo.aag.auditLog.columnFilter.visibleAttributesNote',
  'Clear Filters': 'neo.common.clearFilters',
  'Session Recording': 'activitylog.video.sessionRecording.label',
  'Session {index} of {total}': 'activitylog.video.sessionIndex.label',
  recording: 'activitylog.video.recording.label',
  // Audit Log Export Modal
  Exporting: 'neo.aag.auditLog.export.exporting',
  'Export failed': 'activitylog.export.failed',
  'Export failed. Please try again.': 'activitylog.export.failedFallback',
  'Current Request': 'activitylog.export.currentRequest.label',
  'Export all activity logs related to this request.':
    'activitylog.export.currentRequestDescription.label',
  'Historical Data': 'activitylog.export.historicalData.label',
  'Export activity logs from a specific time period, including older records that may not appear in the current request view.':
    'activitylog.export.historicalDataDescription.label',

  'End date must be on/after start date and within {months} months of start date':
    'activitylog.export.dateRange.help',

  'Exporting...': 'activitylog.export.exporting',
  Export: 'activitylog.export.export.label',
  Close: 'neo.common.close',
  'Failed to Complete Review': 'activitylog.completeReview.failed',
  'Complete Review': 'activitylog.reviewDetail.completeReview.label',
  'Review Completed on': 'activitylog.reviewDetail.reviewCompletedOn.label',
  // Audit Header labels
  'Review and Request Details': 'neo.aag.audit.header.reviewAndRequestDetails',
  'Review Detail': 'activitylog.header.reviewDetail.label',
  'Transaction Overview': 'activitylog.header.transactionOverview.label',
  User: 'activitylog.requestDetail.user.label',
  FFID: 'activitylog.requestDetail.ffid.label',
  'Firefighter Role': 'activitylog.requestDetail.ffRoleName.label',
  'Ticket Number': 'activitylog.requestDetail.ticketNumber.label',
  'Justification (Requestor)': 'neo.aag.audit.header.justification.requestor',
  'Time Requested': 'neo.aag.audit.header.timeRequested',
  'Time Requested in Source System Time':
    'neo.aag.audit.header.timeRequestedInSource',
  'Entitlements Requested':
    'activitylog.requestDetail.requestedEntitlementDisplayNames.label',
  Approver: 'activitylog.requestDetail.approverUserDisplayName.label',
  '-': 'neo.common.dash',
  'Reason Code': 'activitylog.requestDetail.reasonCode.label',
  'Log Start Time': 'neo.aag.auditLog.detail.logStartTime',
  'View Recording': 'activitylog.video.viewRecording.label',
  'Log Start Time (UTC)': 'neo.aag.auditLog.detail.logStartTimeUtc',
  'Log Start Time (Source Time)': 'neo.aag.auditLog.detail.logStartTimeSource',
  Overview: 'activitylog.overview.label',
  'Log Type': 'activitylog.logType.label',
  Entitlement: 'activitylog.entitlementDisplayName.label',
  'Entitlement Deviate?': 'activitylog.entitlementDeviation.label',
  'Entitlement Description': 'activitylog.entitlementDescription.label',
  'Entitlement Function Area': 'activitylog.functionNames.label',
  'Entitlement Deviation': 'activitylog.filters.entitlementDeviation.label',
  'SOX Critical': 'neo.aag.auditLog.detail.soxCritical',
  'Sys Critical': 'neo.aag.auditLog.detail.sysCritical',
  'Change Log Details': 'neo.aag.auditLog.detail.changeLogDetails',
  Object: 'activitylog.object.label',
  'Doc Number': 'neo.aag.auditLog.detail.docNumber',
  Table: 'activitylog.table.label',
  'Table Key': 'activitylog.tableKey.label',
  'Change Indicator': 'activitylog.changeIndicator.label',
  Field: 'activitylog.field.label',
  'Short Text': 'activitylog.shortText.label',
  'Old Value': 'activitylog.oldValue.label',
  'New Value': 'activitylog.newValue.label',
  'Entitlement Log Details': 'neo.aag.auditLog.detail.entitlementLogDetails',
  'Usage Period': 'activitylog.usagePeriod.label',
  'Usage Value': 'activitylog.usageValue.label',
  'Usage Start Date': 'activitylog.usageStartDate.label',
  'Usage End Date': 'activitylog.usageEndDate.label',
  Instance: 'activitylog.instance.label',
  Client: 'activitylog.client.label',
  'Time Zone': 'activitylog.timeZone.label',
  'System Log Details': 'activitylog.detail.systemLogDetails.label',
  Severity: 'activitylog.severity.label',
  Detail: 'activitylog.detail.label',
  'Audit Log Details': 'activitylog.detail.auditLogDetails.label',
  'Audit Class': 'activitylog.auditClass.label',
  Terminal: 'activitylog.terminal.label',
  'Host Name': 'activitylog.hostName.label',
  'Program Name': 'activitylog.programName.label',
  Details: 'activitylog.details.label',
  Functions: 'activitylog.functionNames.label',
  'Business Processes': 'activitylog.businessProcessNames.label',
  'Log ID': 'activitylog.logId.label',
  'Row Log Status': 'activitylog.rowLogStatus.label',
  'Report Creation Time': 'neo.aag.auditLog.detail.reportCreationTime',
  Comment: 'activitylog.detail.comment',
  'No review activity yet.': 'neo.aag.auditLog.detail.noReviewActivity',
  'Resolve Flag': 'activitylog.reviewActivity.resolveFlag.label',
  Hide: 'control.sessions.hide',
  Hierarchy: 'neo.aag.tab_hierarchy',
  High: 'activitylog.severity.high',
  HIGH: 'neo.aag.ad_filter_opt_high_uppercase',
  'High ({riskScore})': 'neo.aag.risk_score_type_high',
  History: 'SOD.SeeHistory.label',
  'Identity Type': 'neo.aag.indentity_type',
  'In Remediation': 'neo.aag.violations_page_in_remediated_tab',
  'In Review': 'neo.aag.violations_page_inreview_tab',
  Inactive: 'CERTS_LIST_INACTIVE',
  'Inherent Risk for Entitlement': 'neo.aag.entitlement.risks.sidepanel.desc',
  'Insight Applied': 'neo.aag.insights_applied',
  Insights: 'neo.aag.violation_page_side_column_insights',
  Internal: 'neo.aag.ad_filter_opt_internal',

  'Job Description': 'jobDescription.sod.label',
  'Job id': 'neo.aag.violation_risk_job_id',
  'Keep up the good work!': 'neo.aag.api_no_data_open_tab_msg',
  L: 'neo.aag.ad_filter_opt_L',
  'Last 7 days': 'neo.aag.ad_filter_opt_last_7_days',
  'Last 14 days': 'neo.aag.ad_filter_opt_last_14_days',
  'Last 24 hours': 'neo.aag.ad_filter_opt_last_24_hrs',
  'Last 30 days': 'neo.aag.ad_filter_opt_last_30_days',
  'Last Name': 'LastName.Default.label',

  'Latest Activity': 'activitylog.latestActivity.label',
  'Least Critical': 'neo.aag.sort_least_critical',
  'Less than 7 days old': 'neo.aag.ad_filter_opt_less_7_days',
  'Less than 14 days old': 'neo.aag.ad_filter_opt_less_14_days',
  'Less than 30 days old': 'neo.aag.ad_filter_opt_less_20_days',
  List: 'neo.aag.violation_page_list',
  'Loading...': 'IdentityMnM.home.loading.text',
  'Locations with Most Violations': 'neo.aag.widget_location_most_violation',
  Locked: 'neo.aag.ad_filter_opt_locked',
  Low: 'activitylog.severity.low',
  LOW: 'neo.aag.ad_filter_opt_low_uppercase',
  'Low ({riskScore})': 'neo.aag.risk_score_type_low',
  Manager: 'manager.sod.label',
  'MC Assigned End Date': 'neo.aag.ad_filter_mc_end_date',
  'MC Assigned Start Date': 'neo.aag.ad_filter_mc_start_date',
  'MC Expiry Date': 'neo.aag.ad_filter_mc_expiry_date',
  Medium: 'activitylog.severity.medium',
  MEDIUM: 'neo.aag.ad_filter_opt_medium_uppercase',
  'Medium ({riskScore})': 'neo.aag.risk_score_type_medium',
  'Moderate ({riskScore})': 'neo.aag.risk_score_type_moderate',
  Mitigate: 'neo.aag.mitigate_label',
  'Mitigate ({count})': 'neo.aag.mitigate_count',
  Mitigated: 'SOD.PreMitigated.MitigatedLabel',
  'Mitigated {count}': 'neo.aag.mitigated_count',
  'Mitigated by': 'neo.aag.mitigated_by',
  'Mitigating Control': 'ReqHist.SOD.Mitigation.MitigatingControl',
  'Remove Mitigating Control': 'neo.aag.remove_mitigating_control',
  '{count, plural, one {Mitigating Control} other {Mitigating Controls}}':
    'neo.aag.mitigating_control_and_controls',
  'Mitigating Control {count}': 'neo.aag.mitigating_control_count',
  'Mitigating Control Added': 'neo.aag.history_mitigate_control_added',
  'Mitigating Control End Date Changed':
    'neo.aag.history_mitigate_control_end_date_change',
  'Mitigating Control Name': 'SOD.MC.label',

  'More than 30 days old': 'neo.aag.ad_filter_opt_more_30_days',
  'Most Critical': 'neo.aag.sort_most_critical',
  'Move to “In Review”': 'neo.aag.move_in_review',
  'Moved From Status to Close': 'neo.aag.history_status_to_close',
  'Moved to In Review': 'neo.aag.history_move_to_in_review',
  'Moved To In-Remediation': 'neo.aag.history_move_to_in_remediation',
  'Moved to In-Review': 'neo.aag.history_move_to_in_review_dash',
  'Multiple occurrences {currentCount} of {totalCount}':
    'neo.aag.multiple_occurances',
  'Newest to Oldest': 'neo.aag.sort_new_to_old',
  Next: 'CERTS_NEXT',
  'Next 7 days': 'neo.aag.ad_filter_opt_nxt_7_days',
  'Next 14 days': 'neo.aag.ad_filter_opt_nxt_14_days',
  'Next 24 hours': 'neo.aag.ad_filter_opt_nxt_24_hrs',
  'Next 30 days': 'neo.aag.ad_filter_opt_nxt_30_days',
  'No data found!': 'neo.aag.api_no_data_found',
  'No Matching Results Found': 'neo.aag.api_no_data_title',
  'No Open Violations': 'neo.aag.api_no_data_title_open_tab',
  'No Entitlements': 'neo.aag.api_no_data_entitlement',
  'No records match your search': 'neo.aag.no_records_message',
  'No Results Found!': 'neo.aag.api_no_function_title',
  None: 'AOB.DnD.None',
  'Not Calculated': 'neo.aag.ad_filter_opt_not_calculated',
  'Not Provided': 'CERTS_NOT_PROVIDED',
  'Number of Assigned Entitlements': 'neo.aag.number_assigned_ent',
  'Number of Violating Entitlements': 'neo.aag.number_violating_ent',
  'Oldest to Newest': 'neo.aag.sort_old_to_new',
  Open: 'REQUEST.ACCESS.STATUS.OPEN',
  'Open Risk SodInsights Aside': 'neo.aag.violations_page_insights_toggler',
  'Org Unit ID': 'orgunitid.sod.label',
  'Orphan Accounts with Most Violations':
    'neo.aag.widget_orp_acc_most_violation',
  'Please select at least one mitigating control.':
    'neo.aag.select_at_least_one_message',
  'Potential Risk': 'neo.aag.ad_filter_opt_potential_risk',
  Preventative: 'neo.aag.ad_filter_opt_preventative',
  Priority: 'neo.aag.priority_label',
  Privileged: 'PRIVILEGED.ATTESTATIONS',
  'Provide a reason for your decision': 'CERTS_TERMINATE_PLACEHOLDER',
  'Re-Open': 'neo.aag.repoen',
  'Recommendations to Reduce Violations':
    'neo.aag.widget_recommendation_reduce_violation',
  '23 Items': 'neo.aag.recommendation.items_count',
  'Recommended Only': 'neo.aag.recommended_only_label',
  'Revoke (23)': 'neo.aag.recommendation.revoke_count',
  'Save to Simulation': 'neo.aag.recommendation.save_to_simulation',
  Refresh: 'activitylog.error.refresh',
  Region: 'region.sod.label',
  Remediate: 'neo.aag.remediate_label',
  'Remediation Request Approved': 'neo.aag.history_remediation_request_approve',
  'Remediation Request Rejected': 'neo.aag.history_remediation_request_reject',
  'Remediation Requested': 'neo.aag.history_remediation_request',
  'Remediation Task Created': 'neo.aag.history_remediation_task_created',
  'Remediation Task Failed': 'neo.aag.history_remediation_task_failed',
  'Remove Filter': 'CERTS_REMOVE_FILTER',
  '{count, plural, one {Remove Mitigating Control} other {Remove Mitigating Controls}}':
    'neo.aag.remove_mitigating_control_and_controls',
  'Remove Mitigating Control ({count})':
    'neo.aag.remove_mitigating_control_count',
  Retry: 'Retry.Default.label',
  'Review Comments Added': 'neo.aag.history_review_comment_added',
  'Review End Date Changed': 'neo.aag.history_review_end_date_change',
  'Risk Description': 'riskDesc.sod.label',
  'Risk Name': 'risks.riskname.label',
  'Risk Owner': 'RiskOwner.Default.label',
  'Risk Priority': 'risks.priority.label',
  'Risk Score': 'Users.riskscore.label',
  'Risk Type': 'risks.risktype.label',
  'Risks with Most Violations': 'neo.aag.widget_risk_most_violation',
  Role: 'Role_DISPLAYNAME.CERTIFICATIONS',
  'Roles Causing Most Violations': 'neo.aag.widget_role_most_violation',
  'Rule Value': 'neo.aag.rule_value',
  Ruleset: 'Rulesets.ruleset.label',
  'Rulesets with Most Violations': 'neo.aag.widget_ruleset_most_violation',
  S: 'neo.aag.ad_filter_opt_S',
  'SAP Roles Causing Most Violations': 'neo.aag.widget_sap_role_most_violation',
  Search: 'neo.aag.search',
  'Search failed; please try again': 'neo.aag.filter_search_failed_text',
  'Search your text here...': 'neo.aag.search_text_here',
  'Select All ({count})': 'neo.aag.select_all_with_count',
  'Select up to {count} widgets to be displayed and drag to reorder them.':
    'neo.aag.customize_widgets_subtitle',
  Selected: 'REASSSIGN_SELECTED',
  'Selection Required': 'neo.aag.selection_required_message',
  service: 'neo.aag.ad_filter_opt_service',
  'Service Account': 'MSA.SERVICE.ACCOUNT',
  'Service Accounts with Most Violations':
    'neo.aag.widget_service_acc_most_violation',
  'Show Less': 'CERTS_SHOW_LESS',
  'Show More': 'CERTS_SHOW_MORE',
  SOD: 'Icon.SOD',
  'Something went wrong while loading the data. Please reload or check back later.':
    'neo.aag.api_error_data_title_2',

  Sort: 'CERTS_SORT',
  Source: 'IdentityMnM.home.source.tooltip',
  'Sox Critical': 'soxcritical.ATTESTATIONS',
  'SOX Critical Entitlements with Most Violations':
    'neo.aag.widget_sox_most_violation',
  Standard: 'neo.aag.ad_filter_opt_standard',
  Start: 'quickRequest.Start',
  'Start Date': 'activitylog.export.startDate.label',
  Summary: 'activitylog.activitySummary.summary.label',
  'System Username': 'SystemUserName.Default.label',
  'T-Codes Causing Most Violations': 'neo.aag.widget_tcode_most_violation',
  'Tap anywhere on the row to open the details panel.':
    'neo.aag.tap_to_open_panel',
  TEST: 'neo.aag.ad_filter_opt_test',
  'The direct cause of the violation of the function.':
    'neo.aag.direct_fn_cause_description',
  'The mitigating control expires soon': 'neo.aag.controls_expire_soon_msg',
  'The number of visible attributes depends on the size of your browser. Any attributes not shown are visible in the':
    'neo.aag.col_filter_description',
  "The user has access to conflicting entitlements but has only used a subset. A violation could occur but hasn't yet been confirmed by full usage.":
    'neo.aag.violation_not_confirmed_tooltip_msg',
  'The user has performed actions using entitlements from all functions involved in the risk. This is a confirmed SoD violation based on usage data.':
    'neo.aag.confirmed_sod_violation_tooltip_msg',
  'This entitlement appears in more than one job function within the same violation. This indicates this entitlement carries inherent risk.':
    'neo.aag.multiple_occurances_description',
  'This page of the violations did not load properly due to a network issue. Please refresh or try again later.':
    'neo.aag.could_not_load_description',
  'This page of the entitlements did not load properly due to a network issue. Please refresh or try again later.':
    'neo.aag.entitlement.could_not_load_description',
  to: 'role.review.to',
  'Total Used': 'neo.aag.total_used',
  Trust: 'CERTS_TRUST',
  'Trust Block Coming Soon...': 'neo.aag.trust_coming_soon',
  'Try clearing the search or check back later.':
    'neo.aag.api_no_data_search_msg',

  'Try updating the filters or check back later.':
    'neo.aag.api_no_data_filter_msg',
  Type: 'CERTS_REVIEW_STEP2_TYPE',
  'Type more than 2 characters to see results.':
    'neo.aag.type_more_than_2_characters_to_see_results',
  'Type number': 'neo.aag.ad_filter_opt_type_num',
  Unlocked: 'neo.aag.ad_filter_opt_unlocked',
  'Update Date': 'Endpoint_UPDATEDATE.ATTESTATIONS',
  'User Not Found.': 'neo.aag.user_not_found',
  'User Value': 'neo.aag.user_value',
  Userlock: 'neo.aag.ad_filter_userlock',
  Username: 'User_USERNAME.ATTESTATIONS',
  Users: 'CERTS_BULK_USERS',
  'Users with Most Violations': 'neo.aag.widget_user_most_violation',
  'Very High': 'neo.aag.ad_filter_opt_very_high',
  'VERY HIGH': 'neo.aag.ad_filter_opt_very_high_uppercase',
  'Very High ({riskScore})': 'neo.aag.risk_score_type_very_high',
  'Very Low': 'neo.aag.ad_filter_opt_very_low',
  'VERY LOW': 'neo.aag.ad_filter_opt_very_low_uppercase',
  'Very Low ({riskScore})': 'neo.aag.risk_score_type_very_low',
  'View All': 'activitylog.activitySummary.viewAll.label',
  'View Details': 'CatalogApplicationViewDetails',
  'View Graph': 'neo.aag.view_graph',
  'View History': 'CERTS_VIEW_HISTORY',
  'View List': 'neo.aag.view_list',
  'Violating Entitlement': 'SOD.appReq.VioEntitlement',
  'Violating Privileged Entitlement': 'neo.aag.violation_prv_ent',
  'Violating SOX Critical Entitlement': 'neo.aag.violation_sox_crt_ent',
  'Violating Sys Critical Entitlement': 'neo.aag.violation_sys_crt_ent',
  'Violation Age': 'neo.aag.ad_filter_violation_age',
  'Violation Age (Day)': 'neo.aag.violation_age_by_day',
  'Violation by': 'neo.aag.violation_by',
  'Violation by {username}': 'neo.aag.violation_by_username',
  'Violation Closed': 'neo.aag.history_violation_closed',
  'Violation Found': 'neo.aag.history_violation_found',
  'Violation Mitigated': 'neo.aag.history_violation_mitigate',
  'Violation Origin': 'neo.aag.ad_filter_violation_origin',
  'Violation Re-Opened': 'neo.aag.history_violation_re_opened',

  Violations: 'neo.aag.tab_violations',
  VIOLATIONS: 'neo.aag.violations_uppercase',
  'Violations Detection': 'neo.aag.violations_detection',
  'Violations Workbench': 'neo.aag.violations_workbench',
  'User Violations': 'neo.aag.user_violations',
  'Entitlement Violations': 'neo.aag.entitlement_violations',
  'Violations Page': 'neo.aag.ad_filter_violations_page',
  "You've reached maximum number of columns sets allowed. Remove existing ones to add more.":
    'neo.aag.col_filter_limit_msg',
  "You've reached maximum number of filter sets allowed. Remove existing ones to add more.":
    'neo.aag.ad_filter_add_remove_filters_with_limit',
  "You've reached the max number": 'neo.aag.max_limit_reached',
  'Z to A': 'neo.aag.sort_z_to_a',
  'Remove Mitigating Control{count, plural, =0 {} =1 {} other { ({count})}}?':
    'neo.aag.remove_mitigating_control_modal_title_count',
  'Confirm Action?': 'neo.aag.confirm_action_modal_title',
  'Move the violation to the “Open” status':
    'neo.aag.confirm_violation_to_open_subtitle',
  'The violation will be moved to the “Open” status.':
    'neo.aag.confirm_violation_to_open_reverse_subtitle',
  'Mitigating Control{count, plural, one {} other {s}} Removed':
    'neo.aag.remove_mc_success_title',
  'Violation {riskName} is moved to "Open" status':
    'neo.aag.remove_mc_success_description',
  'Re-Opened': 'neo.aag.reopen_success_title',
  'Move the violation to the “In Review” status to track its progress.':
    'neo.aag.move_to_inreview_subtitle',
  'Moved to “In Review”': 'neo.aag.moved_to_in_review_success_title',
  'Violation {riskName} is moved to "In Review" status':
    'neo.aag.move_to_inreview_success_description',
  'Mitigating Control Applied': 'neo.aag.mitigate_success_title',
  'Mitigating Control(s) Added': 'neo.aag.addmc_success_title',
  'Comment added for violation {riskName}':
    'neo.aag.add_review_comment_success_description',
  '{count} Violations have been mitigated.':
    'neo.aag.mitigate_bulk_comment_success_description',
  'Violation “{riskName}” has been mitigated.':
    'neo.aag.mitigate_comment_success_description',
  'End date changed for violation {riskName}':
    'neo.aag.review_end_date_change_success_description',
  'Violation {riskName} is in remediation.':
    'neo.aag.remediate_success_description',
  Duration: 'neo.aag..duration',
  'When would you like to start the “In Review” period, and for how long?':
    'neo.aag.when_to_start_review_heading',
  'What are you working on during the review?':
    'neo.aag.what_are_you_working_review_heading',
  'Describe the review activities': 'neo.aag.describe_review_activities',
  'This required field is incomplete': 'neo.aag.required_field_alert',
  Saving: 'activitylog.flag.saving.label',
  'Not able to perform this action.': 'neo.aag.not_able_to_perform_this_action',
  'Action Completed': 'neo.aag.action_completed',
  View: 'neo.aag.view',
  '0 to 7 days old': 'neo.aag.violation_age_0_7_days',
  '0 to 30 days old': 'neo.aag.violation_age_0_30_days',
  '0 to 60 days old': 'neo.aag.violation_age_0_60_days',
  '0 to 90 days old': 'neo.aag.violation_age_0_90_days',
  "This filter can't be cleared in graph view":
    'neo.aag.graph_view_filter_can_not_clear',
  'Graph view supports a maximum 120-day span of violation age per view. Switch to List View for a wider range.':
    'neo.aag.graph_view_filter_can_not_clear_msg',
  'Value should be a number': 'neo.aag.value_should_be_a_number',
  'Value should be greater than 0': 'neo.aag.value_should_be_greater_than_zero',
  'Range exceeds the {count}-day limit for graph view.':
    'neo.aag.range_exceeds_day_limit',
  'Both start and end values are required':
    'neo.aag.both_start_and_end_values_required',
  "Can't clear “Violation Age” filter in graph view.":
    'neo.aag.cant_clear_violation_age_title',
  'The graph supports a maximum {count}-day span per view. Switch to List View for a wider range.':
    'neo.aag.cant_clear_violation_age_description',
  'Switch to List View': 'neo.aag.switch_to_list_view',
  'Changed End Date': 'neo.aag.changed_end_date',
  'End date changed for mitigating controls in violation {riskName}':
    'neo.aag.mitigate_control_enddate_success_description',
  'The violation will remain in a "Mitigated" status because at least one other mitigating control is still active.':
    'neo.aag.vioaltion_will_remain_in_mitigated',
  'Value should be less than 100': 'neo.aag.value_should_be_less_than_100',
  '{startValue} to {endValue} days old': 'neo.aag.violation_age_start_end_days',
  '{startValue} to {endValue}': 'neo.aag.violation_age_start_end_values',
  'Graph view supports a maximum {count}-day span of violation age per view. Switch to List View for a wider range.':
    'neo.aag.graph_120_day_support_text',
  '{count} Moderate Violations':
    'neo.aag.ad_filter_opt_modertate_violation_count',
  'Current View: User Violations': 'neo.aag.violation_report_current_view',
  'Filters Applied': 'neo.aag.violation_report_filter_applied',
  'Priority:': 'neo.aag.priority_colon',
  'Expires:': 'neo.aag.expires_colon',
  'To remediate function {order} ({fnName}) of this violation, revoke the following {entCount} access:':
    'neo.aag.remediate_function_single_message',
  'To remediate function {order} (<functionName>{fnName}</functionName>) of this violation, revoke the following {entCount} access:':
    'neo.aag.remediate_function_single_message',
  'To remediate function {functions} of this violation, revoke the following {entCount} access:':
    'neo.aag.remediate_function_multiple_message',
  'To remediate function (<functionList></functionList>) of this violation, revoke the following {entCount} access:':
    'neo.aag.remediate_function_multiple_message',
  'To remediate function {functionsList} of this violation, revoke the following {entCount} access:':
    'neo.aag.remediate_function_complete_message',
  and: 'neo.aag.and',
  '{count, plural, one {Item} other {Items}}': 'neo.aag_item_and_items',
  '{count, plural, one {# Entitlement} other {# Entitlements}}':
    'neo.aag_entitlement_and_entitlements',
  '{count, plural, one {# item} other {# items}}':
    'neo.aag_item_and_items_lowercase_with_count',
  '{count, plural, one {Violation} other {Violations}}':
    'neo.aag_violation_and_violations',
  'Mitigate {count} {count, plural, one {Violation} other {Violations}}':
    'neo.aag_mitigate_count_violations',
  'Apply one or more mitigating controls to {count, plural, one {violation} other {violations}}':
    'neo.aag_apply_mitigating_controls_to_violations',
  'Apply one or more mitigating controls to {count, plural, one {# violation} other {# violations}} associated with risk':
    'neo.aag_bulk_apply_mitigating_controls_to_violations',
  'Number of {count, plural, one {Assigned Entitlement} other {Assigned Entitlements}}':
    'neo.aag_number_of_assigned_entitlements',

  // Entitlement Tab:
  'Inherent Risks': 'neo.aag.ent.risks',
  'Inherent Risk for': 'neo.aag.ent.risks_sidepanel_description',
  'View Violations': 'neo.aag.ent.risks_violations_menu_option',
  Risk: 'neo.aag.ent.risks_list_risk',
  'Functions:': 'neo.aag.ent.risks_list_functions',
  'No Risks': 'neo.aag.ent.risks_list_No_Risks_title',
  'No Inherent risks found.': 'neo.aag.ent.risks_list_No_Risks_description',
  'Violating Entitlements':
    'neo.aag.ent.risks_sidepanel_violating_entitlements',
  'Custom Property 2': 'neo.aag.ent.risks_sidepanel_custom_property2',
  Items: 'neo.aag.ent.risks_items',
  Item: 'neo.aag.ent.risks_item',
  Privilaged: 'neo.aag.ent.risks_summary_privilaged',
  'User with': 'neo.aag.ent.users_sidepanel_description',
  'No Users': 'neo.aag.ent.users_list_No_Users_title',
  'No users found.': 'neo.aag.ent.users_list_No_Users_description',
  'User Name': 'activitylog.userName.label',
  'System User Name': 'neo.aag.ent.users_sidepanel_system_user_name',
  Title: 'neo.aag.ent.users_sidepanel_title',
  'Department Name': 'neo.aag.ent.users_sidepanel_department_name',
  Status: 'neo.aag.ent.users_sidepanel_status',
  Location: 'neo.aag.ent.users_sidepanel_location',
  External: 'neo.aag.ent.users_list_identity_type',
  // Additional aagLabels entries (non-duplicates only)
  // Removed older duplicates in favor of aag.neo.* keys below
  // Missing keys from response
  'Risk Custom Property 1': 'risks.customproperty1.label',
  'Risk Custom Property 2': 'risks.customproperty2.label',
  'Risk Status': 'risks.status.label',
  'Cost Center Name': 'costcenter.sod.label',
  'System User': 'systemUserName.sod.label',
  'Function Name': 'activitylog.filters.functionNames.label',
  'Function Type': 'function.functiontype.label',
  'Ruleset Name': 'Rulesets.ruleset.label',

  // All response keys
  'Risk Name ': 'risks.riskname.label',
  'Risk Description ': 'riskDesc.sod.label',
  'Risk Priority ': 'riskPriority.sod.label',
  'Risk Type ': 'risks.risktype.label',
  'Risk Owner ': 'RiskOwner.Default.label',
  'User Name ': 'userkey.sod.label',
  'User First Name': 'firstname.sod.label',
  'User Last Name': 'lastname.sod.label',
  'City ': 'city.sod.label',
  'Company Name ': 'companyname.sod.label',
  'Cost Center ': 'costcenter.sod.label',
  'Country ': 'country.sod.label',
  'Department Name ': 'departmentname.sod.label',

  'Email ': 'email.sod.label',
  'Employee Class ': 'employeeclass.sod.label',
  'Employee ID ': 'employeeid.sod.label',
  'Employee Type ': 'employeeType.sod.label',
  'Job Function ': 'job_function.sod.label',
  'Job Code ': 'jobCode.sod.label',
  'Location ': 'location.sod.label',
  'Org Unit ID ': 'orgunitid.sod.label',
  'Region ': 'region.sod.label',
  'Region Code ': 'regionCode.sod.label',
  'System User Name ': 'systemUserName.sod.label',
  'Function Name ': 'function.function_name.label',
  'Function Type ': 'function.functiontype.label',
  'Function Owner ': 'functionOwner.sod.label',
  'Account Names ': 'ACCOUNTS.sod.label',
  'Account Types ': 'accountTypes.sod.label',
  'Account Statuses ': 'sod.accounts.status.label',
  'Ruleset Name ': 'Rulesets.ruleset.label',
  'Assigned Entitlement Display Names ':
    'SODMappedDetail.export.parentrole.label',
  'Assigned Entitlement Custom Property 4 ':
    'entitlement.customproperty4.label',
  'Assigned Entitlement Custom Property 5 ':
    'entitlement.customproperty5.label',
  'Assigned Entitlement Descriptions ': 'entitlement.description.label',
  'Assigned Entitlement Glossaries ': 'entitlement.entitlement_glossary.label',
  'Assigned Entitlement Types ': 'entitlement.entitlementtypekey.label',
  'Assigned Entitlement Privilege Severities ':
    'assignedEntitlementPrivilegeSeverities.sod.label',
  'Assigned Entitlement SOX Severities ':
    'assignedEntitlementSoxSeverities.sod.label',
  'Assigned Entitlement System Severities ':
    'assignedEntitlementSysSeverities.sod.label',
  'Business Process Names ': 'BusinessProcess.Default.label',
  'Mitigating Control Names ': 'MitigatingControl.Default.label',
  'Mitigating Control Descriptions ': 'mitigatingControlDescriptions.sod.label',
  'Endpoint Display Names ': 'Application.Default.label',
  'Violation Status ': 'SodViolationStatus.Default.label',
  'Actual vs Potential ': 'ActualVsPotential.sod.label',
  'Error loading Risks details, please try again.':
    'neo.aag.ent.risks_error_retry',
  'Error loading Violations details, please try again.':
    'neo.aag.ent.violations_error_retry',
  'No Conflicting Job Functions':
    'neo.aag.ent.risks_details_No_Functions_title',
  'No Conflicting Job Functions found':
    'neo.aag.ent.risks_details_No_Functions_description',
  'Number of Auth Objects': 'neo.aag.ent.risks_details_conflicts_SP_objects',
  Value: 'neo.aag.ent.risks_details_conflicts_SP_function',

  // Entitlement Tab Reports
  'Risk Details': 'neo.aag.ent_reports.risk_details',
  'User Details': 'neo.aag.ent_reports.user_details',
  'Entitlement with Inherent Risk':
    'neo.aag.ent_reports.entitlement_with_inherent_risk',
  'Error loading report data, Please try again later.':
    'neo.aag.ent_reports.error_loading_report_data',
  'View All Reports': 'neo.aag.ent_reports.view_all_reports',
  'An export is already in progress for this report type':
    'neo.aag.ent_reports.export_already_in_progress',
  'An export is already in progress for ':
    'neo.aag.ent_reports.export_already_in_progress_for',
  'Exporting ...': 'neo.aag.ent_reports.exporting',
  items: 'neo.aag.ent_reports.items',
  'Entitlements with Inherent Risks':
    'neo.aag.ent_reports.entitlements_with_inherent_risks',
  'A detailed report of entitlements, including violating entitlements and risks, users, and objects.':
    'neo.aag.ent_reports.entitlements_with_inherent_risks_desc',
  "export is running in background. You'll receive an email when your report is ready. You can also download it later from My Downloads in your profile.":
    'neo.aag.ent_reports.export_running_background',
  'export failed. Please try again or contact support if the issue persists.':
    'neo.aag.ent_reports.export_failed_desc',
  'Export in Progress': 'neo.aag.ent_reports.export_in_progress',
  'export is already in progress. Please wait for it to complete.':
    'neo.aag.ent_reports.export_already_in_progress_desc',
  'Export Failed': 'neo.aag.ent_reports.export_failed_title',
  'export has failed. Please try again.':
    'neo.aag.ent_reports.export_has_failed',
  'Failed to fetch report columns':
    'neo.aag.ent_reports.failed_to_fetch_report_columns',
  'Failed to create async export':
    'neo.aag.ent_reports.failed_to_create_async_export',
  'Invalid response format': 'neo.aag.ent_reports.invalid_response_format',
  'Failed to fetch export status':
    'neo.aag.ent_reports.failed_to_fetch_export_status',
  'Invalid response format for export status':
    'neo.aag.ent_reports.invalid_response_format_export_status',
  'Failed to fetch preview': 'neo.aag.ent_reports.failed_to_fetch_preview',
  'Added by:': 'neo.aag.added_by_colon',
  'Start:': 'neo.aag.start_colon',
  'End:': 'neo.aag.end_colon',

  // Neo label variants (to avoid key collisions with legacy labels)
  'Function Owner': 'aag.neo.function.owner.label',
  'User Display Name': 'aag.neo.user.display.name.label',
  'Job Code': 'aag.neo.job.code.label',
  'Region Code': 'aag.neo.region.code.label',
  'Account Names': 'aag.neo.account.names.label',
  'Account Types': 'aag.neo.account.types.label',
  'Account Type': 'aag.neo.account.type.label',
  'Account Statuses': 'aag.neo.account.statuses.label',
  'Business Process Names': 'aag.neo.business.process.names.label',
  'Mitigating Control Names': 'aag.neo.mitigating.control.names.label',
  'Mitigating Control Types': 'aag.neo.mitigating.control.types.label',
  'Mitigating Control Descriptions':
    'aag.neo.mitigating.control.descriptions.label',
  'Endpoint Display Names': 'aag.neo.endpoint.display.names.label',
  'Endpoint Display Name': 'aag.neo.endpoint.display.name.label',
  'Assigned Entitlement Display Names':
    'aag.neo.assigned.entitlement.display.names.label',
  'Assigned Entitlement Display Name':
    'aag.neo.assigned.entitlement.display.name.label',
  'Assigned Entitlement Custom Property 4s':
    'aag.neo.assigned.entitlement.custom.property.4s.label',
  'Assigned Entitlement Custom Property 4':
    'aag.neo.assigned.entitlement.custom.property.4.label',
  'Assigned Entitlement Custom Property 5s':
    'aag.neo.assigned.entitlement.custom.property.5s.label',
  'Assigned Entitlement Custom Property 5':
    'aag.neo.assigned.entitlement.custom.property.5.label',
  'Assigned Entitlement Descriptions':
    'aag.neo.assigned.entitlement.descriptions.label',
  'Assigned Entitlement Description':
    'aag.neo.assigned.entitlement.description.label',
  'Assigned Entitlement Glossaries':
    'aag.neo.assigned.entitlement.glossaries.label',
  'Assigned Entitlement Glossary':
    'aag.neo.assigned.entitlement.glossary.label',
  'Assigned Entitlement Types': 'aag.neo.assigned.entitlement.types.label',
  'Assigned Entitlement Type': 'aag.neo.assigned.entitlement.type.label',
  'Assigned Entitlement Privilege Severities':
    'aag.neo.assigned.entitlement.privilege.severities.label',
  'Assigned Entitlement Privilege Severity':
    'aag.neo.assigned.entitlement.privilege.severity.label',
  'Assigned Entitlement SOX Severities':
    'aag.neo.assigned.entitlement.sox.severities.label',
  'Assigned Entitlement SOX Severity':
    'aag.neo.assigned.entitlement.sox.severity.label',
  'Assigned Entitlement System Severities':
    'aag.neo.assigned.entitlement.sys.severities.label',
  'Assigned Entitlement System Severity':
    'aag.neo.assigned.entitlement.sys.severity.label',
  'Violating Entitlement Display Names':
    'aag.neo.violating.entitlement.display.names.label',
  'Violating Entitlement Display Name':
    'aag.neo.violating.entitlement.display.name.label',
  'Function Entitlement': 'aag.neo.function.entitlement.display.name.label',
  'Violating Entitlement Custom Property 4s':
    'aag.neo.violating.entitlement.custom.property.4s.label',
  'Violating Entitlement Custom Property 4':
    'aag.neo.violating.entitlement.custom.property.4.label',
  'Violating Entitlement Custom Property 5s':
    'aag.neo.violating.entitlement.custom.property.5s.label',
  'Violating Entitlement Custom Property 5':
    'aag.neo.violating.entitlement.custom.property.5.label',
  'Violating Entitlement Descriptions':
    'aag.neo.violating.entitlement.descriptions.label',
  'Violating Entitlement Description':
    'aag.neo.violating.entitlement.description.label',
  'Violating Entitlement Glossaries':
    'aag.neo.violating.entitlement.glossaries.label',
  'Violating Entitlement Glossary':
    'aag.neo.violating.entitlement.glossary.label',
  'Violating Entitlement Types': 'aag.neo.violating.entitlement.types.label',
  'Violating Entitlement Type': 'aag.neo.violating.entitlement.type.label',
  'Violating Entitlement Privilege Severities':
    'aag.neo.violating.entitlement.privilege.severities.label',
  'Violating Entitlement Privilege Severity':
    'aag.neo.violating.entitlement.privilege.severity.label',
  'Violating Entitlement SOX Severities':
    'aag.neo.violating.entitlement.sox.severities.label',
  'Violating Entitlement SOX Severity':
    'aag.neo.violating.entitlement.sox.severity.label',
  'Violating Entitlement System Severities':
    'aag.neo.violating.entitlement.sys.severities.label',
  'Violating Entitlement System Severity':
    'aag.neo.violating.entitlement.sys.severity.label',
  'First Useds': 'aag.neo.first.useds.label',
  'Last Useds': 'aag.neo.last.useds.label',
  'Total Usages': 'aag.neo.total.usages.label',
  'First Used': 'aag.neo.first.used.label',
  'Last Used': 'aag.neo.last.used.label',
  'Total Usage': 'aag.neo.total.usage.label',
  'Access Path': 'aag.neo.access.path.label',
  'Violating Object Name': 'aag.neo.violating.object.name.label',
  'Violating Field Name': 'aag.neo.violating.field.name.label',
  'Violating Field Value': 'aag.neo.violating.field.value.label',
  'Violation Status': 'aag.neo.violation.status.label',
  'Actual vs Potential': 'aag.neo.actual.vs.potential.label',
  'User Status': 'aag.neo.user.status.label',

  // Activity Log Intelligence
  'Security Audit Log': 'activitylog.logType.securityAuditLog.label',
  'Change Log': 'activitylog.logType.changeLog.label',
  'T-Code Log': 'activitylog.logType.tcodeLog.label',
  'System Log': 'activitylog.logType.systemLog.label',
  'Row Header': 'activitylog.rowHeaderName.label',
  'Request ID': 'activitylog.requestDetail.requestId.label',
  'Entitlement SOX Severity': 'activitylog.entitlementSoxSeverity.label',
  'Entitlement System Severity': 'activitylog.entitlementSysSeverity.label',
  'Report Created At': 'activitylog.reportCreatedAt.label',
  'Log Created At': 'activitylog.logCreatedAt.label',
  'Document Number': 'activitylog.docNumber.label',
  'Log Types': 'activitylog.filters.logTypes.label',
  'Change Indicators': 'activitylog.filters.changeIndicators.label',
  'Entitlement Display Names':
    'activitylog.filters.entitlementDisplayNames.label',
  Severities: 'activitylog.filters.severities.label',
  'Audit Classes': 'activitylog.filters.auditClasses.label',
  'Audit Log Statuses': 'activitylog.filters.auditLogStatuses.label',
  Success: 'neo.common.success',
  'Review submitted. You can close this message, or wait to be redirected.':
    'activitylog.review.submitted.redirect.description',
  'Review completed successfully': 'activitylog.review.completed.success',
  'You must resolve all flagged issues':
    'activitylog.review.resolveFlags.title',
  'All flags must be resolved before you can complete the review.':
    'activitylog.review.resolveFlags.subtitle',
  'Review Flagged Items': 'activitylog.review.resolveFlags.primary',
  'Log Duration': 'activitylog.filters.logDuration.label',
  'Export logs for the current request only':
    'activitylog.export.currentRequestDescription.label',
  'Export logs for a specific date range':
    'activitylog.export.historicalDataDescription.label',
  'Select a date range for export': 'activitylog.export.dateRange.help',
  'Failed to export. Please try again.': 'activitylog.export.failedFallback',
  "We couldn't load this session recording right now. Refresh and try again. If the issue continues, contact your administrator.":
    'activitylog.video.failedToFetchVideoData.label',
  'The recording timed out while loading. Please try again.':
    'activitylog.video.timeoutError.label',
  'Failed to load session recording': 'activitylog.video.failedToLoad.label',
  'Failed to initialize player: Required DOM elements not found.':
    'activitylog.video.initPlayer.missingElements.label',
  'Invalid filename provided. Filename failed security validation.':
    'activitylog.video.initPlayer.invalidFilename.label',
  'Failed to initialize player: initPlayer function not found.':
    'activitylog.video.initPlayer.functionNotFound.label',
  'Failed to initialize session recording player.':
    'activitylog.video.initPlayer.failed.label',
  Recording: 'activitylog.video.recording.label',
  'No Session Recording Found': 'activitylog.video.noRecordingFound.label',
  'Video Play Error': 'activitylog.video.playError.title',
  'Session recording could not start automatically. Try pressing Play to start playback.':
    'activitylog.video.playError.description',
  'Add Comments': 'activitylog.comment.addComments.label',
  'Add a note to this log item without flagging it. Use this to document context, questions, or general observations during review.':
    'activitylog.comment.addNoteDescription.label',
  'Write your comment': 'activitylog.comment.writeYourComment.label',
  'Review Activity': 'activitylog.activitySummary.reviewActivity.label',
  'Activity Summary': 'activitylog.reviewDetail.activitySummary.label',
  'Flag Resolved': 'activitylog.activitySummary.flagResolved.label',
  Flagged: 'activitylog.reviewActivity.flagged.label',
  'Resolved by': 'activitylog.activitySummary.resolvedBy.label',
  'Flagged by': 'activitylog.reviewActivity.flaggedBy.label',
  'No Review Activity': 'activitylog.reviewActivity.noReviewActivity.label',
  'No Activity Recorded': 'activitylog.activitySummary.noActivityFound',
  'High Risk': 'activitylog.insight.highRisk.label',
  'Low Risk': 'activitylog.insight.lowRisk.label',
  'Medium Risk': 'activitylog.insight.mediumRisk.label',
  'Usage Count': 'activitylog.insight.usageCount.label',
  'Critical Configuration Changes':
    'activitylog.insight.criticalConfigurationChanges.label',
  'Users Created/Updated/Deleted':
    'activitylog.insight.usersCreatedUpdatedDeleted.label',
  'Entitlement Changes': 'activitylog.insight.entitlementChanges.label',
  'Vendor Master Changes': 'activitylog.insight.vendorMasterChanges.label',
  'Customer Master Changes': 'activitylog.insight.customerMasterChanges.label',
  'All Logs': 'activitylog.header.allLogs.label',
  'Request Key': 'activitylog.requestDetail.requestKey.label',
  'Task ID': 'activitylog.requestDetail.taskId.label',
  'Connection Type': 'activitylog.requestDetail.connectionType.label',
  'Application Type': 'activitylog.requestDetail.applicationType.label',
  Requestor: 'activitylog.requestDetail.requestorUserDisplayName.label',
  'Business Justification':
    'activitylog.requestDetail.businessJustification.label',
  'Request Start': 'activitylog.requestDetail.requestStartedAt.label',
  'Source Time Zone':
    'activitylog.requestDetail.sourceTimeZoneRequestStartedAt.label',
  'Request End': 'activitylog.requestDetail.requestEndedAt.label',
  'Endpoint Key': 'activitylog.requestDetail.endpointKey.label',
  Endpoint: 'activitylog.requestDetail.endpointDisplayName.label',
  'Endpoint Logo': 'activitylog.requestDetail.endpointLogo.label',
  'Reviewed By': 'activitylog.reviewDetail.reviewedBy.label',
  'Reviewed At': 'activitylog.reviewDetail.reviewedAt.label',
  'Log Type Description': 'activitylog.logType.logTypeDescription.label',
  Save: 'activitylog.flag.save.label',
  'Flagged and then resolved': 'activitylog.flag.flaggedAndResolved.label',
  'View All Activities': 'activitylog.flag.viewAllActivities.label',
  'This item was flagged for investigation. To complete the review, resolve the flag and explain how the issue was handled.':
    'activitylog.flag.flaggedDescription.label',
  Resolving: 'activitylog.flag.resolving.label',
  'To resolve this issue and remove the flag, provide a brief explanation of what was done to address it.':
    'activitylog.flag.resolveDescription.label',
  'Add a brief explanation for resolution.':
    'activitylog.flag.resolveComment.placeholder',
  Flag: 'activitylog.flag.flag.label',
  'Flag this item if it appears suspicious or requires further investigation before the review can be completed.':
    'activitylog.flag.flagDescription.label',
  'Describe what seems unusual or why this requires attention.':
    'activitylog.flag.flagComment.placeholder',
  'Logs Are Being Processed': 'activitylog.error.logsBeingProcessed.title',
  'Activity logs will be available once processing is complete. Please refresh the page in a few minutes.':
    'activitylog.error.logsBeingProcessed.subtitle',
  'Log Ingestion Not Started': 'activitylog.error.ingestionNotStarted.title',
  'Activity logs are not yet available. Ingestion has not started for this request. Please check back later or contact your administrator.':
    'activitylog.error.ingestionNotStarted.subtitle',
  'Something went wrong': 'activitylog.error.somethingWentWrong.title',
  'Access Denied': 'activitylog.error.requestDetailsAccessDenied.title',
  'You do not have permission to access this session. Request access from your administrator if you think this is a mistake.':
    'activitylog.error.requestDetailsAccessDenied.subtitle',
  'You do not have permission to take any action. Request access from your administrator if you think this is a mistake.':
    'activitylog.error.mutationAccessDenied.subtitle',
  'Review is still in progress. Please come back later once review is completed.':
    'activitylog.error.reviewStillInProgress.subtitle',
  'An unexpected error occurred': 'activitylog.error.unexpectedError',
  'Could not load Page': 'activitylog.error.couldNotLoadPage',
  'This section did not load properly due to a network issue. Please refresh or try again later.':
    'activitylog.error.networkIssue',
  'Review comment added successfully': 'activitylog.success.commentAdded',
  'Log item flagged successfully for review': 'activitylog.success.itemFlagged',
  'Log item reviewed and resolved successfully':
    'activitylog.success.itemResolved',
  'Review Failed': 'activitylog.failure.reviewFailed.title',
  'Something went wrong, please try again.':
    'activitylog.failure.reviewFailed.description',
  'Failed to add comment': 'activitylog.failure.failedToAddComment',
  'Failed to post review': 'activitylog.failure.failedToPostReview',
  'This T-Code was not part of the approved request':
    'activitylog.deviation.tooltip',
  'Add your review comments (minimum 10 characters)':
    'activitylog.completeReview.comments.placeholder',
  'Required fields ({count}) are missing.':
    'activitylog.completeReview.requiredFieldsMissing',
  '{count} item{plural} flagged': 'activitylog.completeReview.itemsFlagged',
  '{count} item{plural} flagged and resolved':
    'activitylog.completeReview.itemsFlaggedAndResolved',
  '{count} item{plural} commented': 'activitylog.completeReview.itemsCommented',
  '{count} Flag{plural} Need{needPlural} Resolution':
    'activitylog.completeReview.flagChip.label',
  'Failed to complete review. Please try again.':
    'activitylog.completeReview.failedMessage',
  'Displaying items related to the insight: ':
    'activitylog.insight.filterPrefix',
  'Failed to load request details. Please refresh the page.':
    'activitylog.error.failedToLoadRequestDetails',
  'Failed to load filters. Retry': 'activitylog.error.failedToLoadFilters',
  'No filters available': 'activitylog.error.noFiltersAvailable',
  'Search failed, Please try again': 'activitylog.error.searchFailed',
  'No results found': 'activitylog.error.noResultsFound',
  'No log details found': 'activitylog.error.noLogDetailsFound',
  'No transactions found matching your filters':
    'activitylog.error.noTransactionsMatchingFilters',
  'Try adjusting your filters or search terms to see more results.':
    'activitylog.error.tryAdjustingFiltersOrSearch',
  'Try adjusting your filters or check back later. If the issue, persists, contact your administrator.':
    'activitylog.error.tryAdjustingFilters',
  'No comment': 'activitylog.comment.noComment',
  'Drag to Reorder': 'activitylog.tooltip.dragToReorder',
  Resolved: 'activitylog.status.resolved',
  'This reflects the original time and time zone of the system that generated the log.':
    'activitylog.tooltip.logStartTime',
  'Indicates whether the T-Code executed in this session was part of the approved request.':
    'activitylog.tooltip.entitlementDeviation',
  'Add your comment': 'activitylog.input.addComment.placeholder',
  more: 'activitylog.button.more',
  Yes: 'activitylog.label.yes',
  'Close insights panel': 'activitylog.button.closeInsightsPanel',
  'View Comments': 'activitylog.menu.viewComments',
  'Transaction Code Description':
    'activitylog.label.transactionCodeDescription',
  'Function Area': 'activitylog.label.functionArea',
  'Role Maintenance': 'activitylog.label.roleMaintenance',
  Columns: 'activitylog.button.columns',

  // Violations report (violationsReportConstants + ReportTable / ReportPreview)
  'Account Name': 'neo.aag.violations_report.account_name',
  actionColumn: 'neo.aag.violations_report.action_column',
  Ascending: 'neo.aag.violations_report.sort_ascending',
  Descending: 'neo.aag.violations_report.sort_descending',
  'User Violations - Summary':
    'neo.aag.violations_report.user_violations_summary',
  'Lists each user violation as a single record.':
    'neo.aag.violations_report.summary_description',
  'User Violations - Detail':
    'neo.aag.violations_report.user_violations_detail',
  'Expands on the Summary by breaking down each violation into individual assigned entitlements and roles.':
    'neo.aag.violations_report.detail_description',
  'User Violations - Permissions':
    'neo.aag.violations_report.user_violations_permissions',
  '(Specific to SAP) Expands on the Detail by including transaction codes and objects that contribute to violations.':
    'neo.aag.violations_report.permissions_description',
  'Lists entitlements with inherent risks, including risk details and user assignments.':
    'neo.aag.violations_report.inherent_risks_template_description',
  'Violations with Mitigating Controls Ending in 30 days':
    'neo.aag.violations_report.mitigating_controls_30_days_title',
  'A list of user violations where the assigned mitigating controls are set to end within the next 30 days.':
    'neo.aag.violations_report.mitigating_controls_30_days_description',
  'Includes assigned entitlements and roles.':
    'neo.aag.violations_report.report_type_detail_secondary',
  'Includes transaction codes that contribute to violations.':
    'neo.aag.violations_report.report_type_permissions_secondary',
  Permissions: 'neo.aag.violations_report.permissions_label',
  'Assigned Entitlement': 'neo.aag.violations_report.assigned_entitlement',
  'Current View: ': 'neo.aag.violations_report.title_prefix_current_view',
  'Template: ': 'neo.aag.violations_report.title_prefix_template',
  'My Report: ': 'neo.aag.violations_report.title_prefix_my_report',
  Conflicts: 'neo.aag.details.tab_conflicts',

  // Violations workbench (`violations.ts` advanced filter categories + risk score buckets)
  'Risk/Violation': 'neo.aag.violations_filter.cat_risk_violation',
  Rulesets: 'neo.aag.violations_filter.cat_rulesets',
  Applications: 'neo.aag.violations_filter.cat_applications',
  'Mitigating Control (MC)':
    'neo.aag.violations_filter.cat_mitigating_control_mc',
  'Moderate (25 to 50)': 'neo.aag.violations_filter.risk_score_range_moderate',
  'High (51-75)': 'neo.aag.violations_filter.risk_score_range_high',
  'Critical (76 - 100)': 'neo.aag.violations_filter.risk_score_range_critical',

  // Audit log — transaction overview filters / sorts (`AuditLogViewerAuditorLeftBody/constants.ts`)
  All: 'activitylog.transactionOverview.filter.all',
  'With Deviations': 'activitylog.transactionOverview.filter.withDeviations',
  'Without Deviations':
    'activitylog.transactionOverview.filter.withoutDeviations',
  'High Usage': 'activitylog.transactionOverview.filter.highUsage',
  'Low Usage': 'activitylog.transactionOverview.filter.lowUsage',
  'Name (A-Z)': 'activitylog.transactionOverview.sort.nameAsc',
  'Name (Z-A)': 'activitylog.transactionOverview.sort.nameDesc',
  'Usage Count (High to Low)':
    'activitylog.transactionOverview.sort.usageCountHighToLow',
  'Usage Count (Low to High)':
    'activitylog.transactionOverview.sort.usageCountLowToHigh',
  'Duration (High to Low)':
    'activitylog.transactionOverview.sort.durationHighToLow',
  'Duration (Low to High)':
    'activitylog.transactionOverview.sort.durationLowToHigh',
  'Review Details': 'activitylog.smartFilters.tab.reviewDetails',
  'Commented ({count})': 'activitylog.status.commentedWithCount',

  // Entitlement reports columns (`entColumnTypes` / ENT_REPORT_COLUMN_CONFIGS)
  'Risk Level': 'neo.aag.ent_reports.column.risk_level',
  'Entitlement Name': 'neo.aag.ent_reports.column.entitlement_name',
  'Assigned Date': 'neo.aag.ent_reports.column.assigned_date',

  // Violations report overflow menu (`ReportActions.tsx`)
  'Save as': 'neo.aag.violations_report.action_save_as',
  Rename: 'neo.aag.violations_report.action_rename',
  Revert: 'neo.aag.violations_report.action_revert',
  Delete: 'neo.aag.violations_report.action_delete',

  // Violations tab demo placeholders (`ViolationsRole` / `ViolationsTime` / `ViolationsUser`)
  'This tab content is placeholder. Please take a look at more of these pages.':
    'neo.aag.violations_tab.demo_placeholder',
  'Go To Recommendations Page': 'neo.aag.violations_tab.go_to_recommendations',
  'Go To Report Page': 'neo.aag.violations_tab.go_to_report',
  'Go To Details Page': 'neo.aag.violations_tab.go_to_details',

  'No available filter!': 'neo.aag.violations_filter.no_available_filter',
  'Line Chart': 'neo.aag.chart.line_chart_title',

  // Merged from former aagLabels
  ' Selected': 'neo.aag.auto.selected',
  'Account:': 'neo.aag.auto.account_colon',
  Applying: 'neo.aag.auto.applying',
  'Choose the level of details you want to include. You can modify them during preview.':
    'neo.aag.auto.choose_the_level_of_details_you_want_to_include_you_can_modify_them_during_preview',
  'Close panel': 'neo.aag.auto.close_panel',
  Confirming: 'neo.aag.auto.confirming',
  'Conflict Details': 'neo.aag.auto.conflict_details',
  'Current View': 'neo.aag.auto.current_view',
  'Data not found': 'neo.aag.auto.data_not_found',
  'Do you want to update this report with your latest filters and columns?':
    'neo.aag.auto.do_you_want_to_update_this_report_with_your_latest_filters_and_columns',
  Download: 'neo.aag.auto.download',
  'Error loading history details, please try again.':
    'neo.aag.auto.error_loading_history_details_please_try_again',
  Exit: 'neo.aag.auto.exit',
  'Exit Fullscreen': 'neo.aag.auto.exit_fullscreen',
  'Export Completed': 'neo.aag.auto.export_completed',
  Exported: 'neo.aag.auto.exported',
  'Insight applied': 'neo.aag.auto.insight_applied',
  'Last Date': 'neo.aag.auto.last_date',
  Loading: 'neo.aag.auto.loading',
  'My Report': 'neo.aag.auto.my_report',
  Name: 'neo.aag.auto.name',
  'New End Date': 'neo.aag.auto.new_end_date',
  'No Insights Available': 'neo.aag.auto.no_insights_available',
  'No Personalized Report Yet': 'neo.aag.auto.no_personalized_report_yet',
  'No Record Found. Change some filters and try again.':
    'neo.aag.auto.no_record_found_change_some_filters_and_try_again',
  'No Records': 'neo.aag.auto.no_records',
  'No Records Found!': 'neo.aag.auto.no_records_found',
  'No Records Found.': 'neo.aag.auto.no_records_found_period',
  'No Violations': 'neo.aag.auto.no_violations',
  'No violations found.': 'neo.aag.auto.no_violations_found',
  Now: 'neo.aag.auto.now',
  Previous: 'neo.aag.auto.previous',
  Remediated: 'neo.aag.auto.remediated',
  Remove: 'neo.aag.auto.remove',
  'Request to Revoke': 'neo.aag.auto.request_to_revoke',
  'Reviewed by': 'neo.aag.auto.reviewed_by',
  Revoke: 'neo.aag.auto.revoke',
  'Save Changes?': 'neo.aag.auto.save_changes_question',
  'Save as New Report': 'neo.aag.auto.save_as_new_report',
  'Save the report filters, columns, and sort settings for quick access in the future. Give it a unique name that’s easy to reference.':
    'neo.aag.auto.save_the_report_filters_columns_and_sort_settings_for_quick_access_in_the_future_give_it_a_unique_name_that_s_easy_to_reference',
  'Save to My Report': 'neo.aag.auto.save_to_my_report',
  'Save your current filters, columns, and sort order as a new report in “My Reports”. Give it a unique name that’s easy to reference.':
    'neo.aag.auto.save_your_current_filters_columns_and_sort_order_as_a_new_report_in_my_reports_give_it_a_unique_name_that_s_easy_to_reference',
  'State Date': 'neo.aag.auto.state_date',
  'Status:': 'neo.aag.auto.status_colon',
  'Still loading. Please retry.': 'neo.aag.auto.still_loading_please_retry',
  'T-Codes Requested': 'neo.aag.auto.t_codes_requested',
  Templates: 'neo.aag.auto.templates',
  'This will discard all unsaved changes and restore the last saved version.':
    'neo.aag.auto.this_will_discard_all_unsaved_changes_and_restore_the_last_saved_version',
  'Type:': 'neo.aag.auto.type_colon',
  Update: 'neo.aag.auto.update',
  Violation: 'neo.aag.auto.violation',
  'You can update filters and columns during preview.':
    'neo.aag.auto.you_can_update_filters_and_columns_during_preview',
  'Your browser does not support the video tag.':
    'neo.aag.auto.your_browser_does_not_support_the_video_tag',
  'export has completed successfully.':
    'neo.aag.auto.export_has_completed_successfully',
  from: 'neo.aag.auto.from',
  'to remediate': 'neo.aag.auto.to_remediate',
  '•': 'neo.aag.auto.msg',
  'Add mitigation controls is only available when all selected violations are of the same risk':
    'neo.aag.auto.add_mitigation_controls_is_only_available_when_all_selected_violations_are_of_the_same_risk',
  'Back to Risk SodInsights List': 'neo.aag.auto.back_to_risk_sodinsights_list',
  'Close Risk SodInsights Aside': 'neo.aag.auto.close_risk_sodinsights_aside',
  Commented: 'neo.aag.auto.commented',
  'Commented By': 'neo.aag.auto.commented_by',
  'Flagged By': 'neo.aag.auto.flagged_by',
  'Mitigation is only available when all selected violations are of the same risk':
    'neo.aag.auto.mitigation_is_only_available_when_all_selected_violations_are_of_the_same_risk',
  Recommendations: 'neo.aag.auto.recommendations',
  'Resolved By': 'neo.aag.auto.resolved_by',
  'Review the result of the remediation simulation, then apply the change or save to simulation workbench for later.':
    'neo.aag.auto.review_the_result_of_the_remediation_simulation_then_apply_the_change_or_save_to_simulation_workbench_for_later',
  'This is account data.': 'neo.aag.auto.this_is_account_data',
  'Toggle recommended': 'neo.aag.auto.toggle_recommended',
  left: 'neo.aag.auto.left',
  select: 'neo.aag.auto.select',
  unselect: 'neo.aag.auto.unselect',
  'Remediate Option': 'neo.aag.remediate.options',
  'An unexpected error occurred. Please contact system administrator.':
    'neo.aag.auto.an_unexpected_error_occurred_please_contact_system_administrator',
  'Bad Request': 'neo.aag.auto.bad_request',
  'You do not have permission to perform this action.':
    'neo.aag.auto.you_do_not_have_permission_to_perform_this_action',

  /** Accessible names — Phase 2 (icon-only, charts, overlays) */
  'Add filter': 'neo.aag.a11y.add_filter',
  'Cancel seek': 'neo.aag.a11y.cancel_seek',
  'Evidence log entries': 'neo.aag.a11y.evidence_log_entries',
  'Extend end date': 'neo.aag.a11y.extend_mitigating_end_date',
  'Finding actions': 'neo.aag.a11y.finding_actions',
  'Key evidence': 'neo.aag.a11y.key_evidence',
  'More actions': 'neo.aag.a11y.more_actions',
  'Play or pause': 'neo.aag.a11y.play_or_pause',
  'Reset zoom': 'neo.aag.a11y.reset_zoom',
  'Toggle date filter': 'neo.aag.a11y.toggle_date_filter',
  'Zoom in': 'neo.aag.a11y.zoom_in',
  'Zoom out': 'neo.aag.a11y.zoom_out',

  /** Phase 3 — shell, dialogs, chart application, kill chain */
  'Skip to main content': 'neo.aag.a11y.skip_to_main_content',
  'Close finding details': 'neo.aag.a11y.close_finding_details',
  'Finding details': 'neo.aag.a11y.finding_details',
  'Session activity timeline chart': 'neo.aag.a11y.session_timeline_chart',
  'View finding details': 'neo.aag.a11y.view_finding_details',
  'Open session {sessionId}': 'neo.aag.a11y.open_session',
  'Expand or collapse log details': 'neo.aag.a11y.expand_collapse_log_details',
  'Expand or collapse finding {title}':
    'neo.aag.a11y.expand_collapse_finding_title',
  'Mark reviewed': 'neo.aag.a11y.mark_reviewed_finding',
  Escalate: 'neo.aag.a11y.escalate_finding',
} as const;

export default invertedMessages;
